import React, { useEffect } from "react";
import { Button, Col, HeadingText, Link, Container, Row, BodyText } from '@paypalcorp/pp-react';
import { launchRedirect } from '../../lib/validate';
import GivingHeader from "./GivingHeader";
import withTheme from "../withTheme";
import { bindFPTIClicks } from '../domUtils';
import GivingFooter from "./GivingFooter";
import * as FPT from '../../utility/fpt';

function CommonComponent(props) {
    useEffect(() => {
        bindFPTIClicks();
        FPT.trackPage(`main:givingfund:${props.propertyInfo.pageName}`);
    }, [])

    return (
        <>
            <GivingHeader merchantHeader={props.propertyInfo.merchantHeader} confirmationFlow={props.propertyInfo.confirmationFlow} />
            <Container style={{ minHeight: '300px', textAlign: 'center', maxWidth: '50rem', placeItems: 'center', alignItems: 'center', display: 'grid' }}>
                <Row style={{ marginTop: '50px' }}>
                    <Col>
                        <img width="120" src={props.propertyInfo.image} alt='' />
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col>
                        {props.propertyInfo.title && <HeadingText size="sm" className="headText" style={{ marginBottom: '24px' }}>{props.propertyInfo.title}</HeadingText>}
                        {props.propertyInfo.description && <BodyText level={1} size="lg" style={{ marginBottom: '52px' }}>{props.propertyInfo.description}</BodyText>}
                        {props.propertyInfo.button && <Button data-fpti={props.propertyInfo.btnFpti} aria-haspopup="true" onClick={() => launchRedirect(props.propertyInfo.linkOne)}>{props.propertyInfo.button}</Button>}
                        {props.propertyInfo.link && <div style={{ marginTop: '24px' }}>
                            <Link data-fpti={props.propertyInfo.linkFpti} href={props.propertyInfo.linkTwo}>{props.propertyInfo.link}</Link>
                        </div>}
                    </Col>
                </Row>
            </Container>
            {props.propertyInfo.merchantFooter  && <GivingFooter merchantFooter={props.propertyInfo.merchantFooter} />}
        </>
    )
}
export default withTheme(CommonComponent);